import { useMutation } from "@tanstack/react-query";
import type { ColumnFiltersState } from "@tanstack/react-table";
import { clientToServerFiltering } from "../../../components/table/utils";
import { useDates } from "../../../dates/DatesContext";
import { useAppSelector } from "../../../redux/hooks";
import { apiClient } from "../../../zodios/client";

const REPORT_TYPE_MAP: Record<string, string> = {
  query: "str_query_report",
  "keyword_text,query,match_type,campaign_id,adv_keyword_id": "str_query_keyword_report",
  "keyword_text,query,match_type,campaign_id,adv_target_id": "str_query_keyword_report",
  keyword: "str_keyword_report",
};

export const useV4SearchTermReportExport = (dimensions: string = "keyword", filters: ColumnFiltersState) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const { start, end } = useDates();

  const reportType = REPORT_TYPE_MAP[dimensions] ?? "str_keyword_report";

  return useMutation({
    mutationFn: async () =>
      await apiClient.getV4SearchTermReportExport({
        queries: {
          start_date: start.format("YYYY-MM-DD"),
          end_date: end.format("YYYY-MM-DD"),
          report_type: reportType,
          grouping: dimensions,
          marketplace: marketPlace,
          filters: clientToServerFiltering(filters),
        },
        responseType: "blob",
      }),
  });
};
